import React, { useEffect, useRef, useState } from 'react'
import ContactForm from './ContactForm'
import { ContactWrapper, TextWithStyledWrapper } from './Styled'
import { Col, Container, Row } from 'react-bootstrap'
import { TextButton, TextWithIcon } from '../../../ui/CustomElements'
import { Box, MainHeading, PrimaryHeading, SpanStyled, SubHeadingStyled, TextStyled, } from '../../../ui/Elements'
import { ContactEmail, ContactInstagram, ContactLinkedin, ContactPhone, ContactX, Instagram, LinkedIn, Location, SnapChat, Tiktok, Twitter } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
// import Footer from '../../footer/Footer'
import i18n from '../../../Languages/INEXT'
import { Animate } from 'react-simple-animate'
const Contact = () => {
	const WhatsApp = () => {
        const phoneNumber = '+966505531205';
        const message = 'Hello, this is Al Asas';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
	const Map = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d463880.77860431897!2d46.19869420819644!3d24.724525635156105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03890d489399%3A0xba974d1c98e79fd5!2sRiyadh%20Saudi%20Arabia!5e0!3m2!1sen!2s!4v1773521162758!5m2!1sen!2s"
	const { t } = useTranslation();
	const sectionRef = useRef(null);
	const [isVisible, setIsVisible] = useState(false);
	const socialIcon = [
			
		/* {
			img: <LinkedIn />,
			link: 'https://www.linkedin.com/',
		}, */
		{
			img: <Twitter />,
			link: 'https://x.com/alasass_sa',
		},
		{
			img: <Instagram />,
			link: 'https://www.instagram.com/alasass.sa?igsh=NzYwanYzMXoxbXhz',
		},
		{
			img: <Tiktok />,
			link: 'https://www.tiktok.com/@alasass.sa?_r=1&_t=ZS-955iw2vjtNy',
		},
		/*{
			img: <SnapChat />,
			link: 'https://snapchat.com/',
		}, */
		/*  */
	]
	useEffect(() => {
			const observer = new IntersectionObserver(
				([entry]) => {
					// When visible, set to true
					if (entry.isIntersecting) {
						setIsVisible(true);
						observer.disconnect(); // run animation once
					}
				},
				{
					threshold: 0.2, // 20% of section visible triggers the animation
				}
			);
	
			if (sectionRef.current) {
				observer.observe(sectionRef.current);
			}
	
			return () => observer.disconnect();
		}, []);
		
		const start = i18n.language === "ar"
		? { clipPath: "inset(0 0 0 100%)" }   // Arabic → reveal right → left
		: { clipPath: "inset(0 100% 0 0)" };  // English → reveal left → right
		const end = { clipPath: "inset(0 0% 0 0)" };
		const start2 = { opacity: 0, transform: 'translateY(-20px)' };
		const end2 = { opacity: 1, transform: 'translateY(0)' };
		const start3 = { opacity: 0, transform: 'translateY(0px)' };
		const end3 = { opacity: 1, transform: 'translateY(0)' };
	return (
		<>
			<ContactWrapper id='contact' className='contact-bg container-fluid' ref={sectionRef}>

				<Container>
					<Box className='containerContact'>
						<Row>
							<Col md={12} className='contact-Us-detail'>
								<Row className=''>
									<Col md={12}>
										<Box className='projDescRow row'>
											<Col md={12} lg={6} className="servicesDescCol servicesDescCol1">
<Animate
																							play={isVisible}
																							duration={1.5}
																							// delay={-0.5}
																							
																
																							start={start}
																							end={end}
																						>
												<PrimaryHeading className='main-heading mb-1 projH' color="var(--text)">
													{t('ContactUs')}
												</PrimaryHeading>
</Animate>
											</Col>
											<Col md={12} lg={6} className="servicesDescCol servicesDescCol2">
<Animate
																													play={isVisible}
																													duration={1}
																													delay={.8}
																													start={start2}
																													end={end2}
																												>
												<SpanStyled className='d-flex mb-4 projTxt' color="var(--text)">
													{t('welcomeContent')}
												</SpanStyled>
</Animate>
											</Col>
										</Box>
									</Col>
								</Row>
								
							</Col>
							<Col lg={6} md={12} className='contact-Us-detail'>
								<Box className='contect-with-us'>
									<Animate
																												play={isVisible}
																												duration={1}
																												delay={1.2}
																												start={start3}
																												end={end3}
																											>
									<ContactForm />
									</Animate>
								</Box>
							</Col>
							<Col lg={6} md={12} className='contact-Us'>
							<Animate
																												play={isVisible}
																												duration={1}
																												delay={1.6}
																												start={start3}
																												end={end3}
																											>
								<Box className='contactDetailCol'>
									
									<Box className='contactComBox'>
										
										<Box className='contact-info'>
											<TextButton clName="dgts engReg wtpBtnCon" icon={ContactPhone} label='+966 50 553 1205' onClick={WhatsApp} color="var(--text)" />
											<TextWithIcon icon={ContactEmail} title='info@alasass.sa' href="mailto:info@alasass.sa" color="var(--text)" />
											<TextWithStyledWrapper className="d-flex cInfoIt align-items-start">
												<Box className='d-flex align-items-center justify-content-center contact-svg'>
													<Location width='26px' />
												</Box>
												<Box>
													<Box className='contactComBox'>
																							
														<SpanStyled className='d-flex addrTxt' family="var(--medium)" color='var(--text)'>
															{i18n.language === "ar" ? 
																<>
																	<span>{t('AddressTxt')}&nbsp;</span><span className='engReg'>{t('AddressTxt1')}&nbsp;</span><span>{t('AddressTxt2')}</span>
																		{/* &nbsp;</span><span className='engReg'>{t('AddressTxt3')}&nbsp;</span><span>{t('AddressTxt4')}</span> */}
																</>
															: 
																<>
																	{t('AddressTxt')}
																</>
															}
															
														</SpanStyled>
													</Box>
												</Box>
											</TextWithStyledWrapper>
										</Box>
									</Box>
									<Box className='contactComBox no-border mt-4'>
										{/* <Box className='contactComHeading'>
											{t('StayConnected')}
										</Box> */}
										<Box className='Social-links'>
											{
												socialIcon.map((list, key) => (
													<a href={list.link} target="_blank" key={key} className='contact-links'>
														{list.img}
													</a>
												))
											}
										</Box>
									</Box>

									
								</Box>
								<Box className='contect-with-you'>
									<Box className='contact-box'>
									<iframe src={Map} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" height="100%" width="100%"></iframe>
									</Box>
								</Box>
								</Animate>
								
							</Col>
							
						</Row>
					</Box>
				</Container>

			</ContactWrapper>
		</>
	)
}

export default Contact